import { render, staticRenderFns } from "./CustomerMarketData.vue?vue&type=template&id=6fe7481e&scoped=true&"
import script from "./CustomerMarketData.vue?vue&type=script&lang=js&"
export * from "./CustomerMarketData.vue?vue&type=script&lang=js&"
import style0 from "./CustomerMarketData.vue?vue&type=style&index=0&id=6fe7481e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe7481e",
  null
  
)

export default component.exports